<template>
  <!-- prettier-ignore -->
  <div :class="loadingClasses">
    <div class="indicator">
      <svg xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.0" width="64px" height="64px" viewBox="0 0 128 128" xml:space="preserve">
         <rect x="0" y="0" width="100%" height="100%" fill="transparent" />
         <g>
            <linearGradient id="linear-gradient">
               <stop offset="0%" stop-color="transparent" fill-opacity="0"/>
               <stop offset="100%" stop-color="#191919" fill-opacity="1"/>
            </linearGradient>
            <path d="M63.85 0A63.85 63.85 0 1 1 0 63.85 63.85 63.85 0 0 1 63.85 0zm.65 19.5a44 44 0 1 1-44 44 44 44 0 0 1 44-44z" fill="url(#linear-gradient)" fill-rule="evenodd"/>
            <animateTransform attributeName="transform" type="rotate" from="0 64 64" to="360 64 64" dur="1080ms" repeatCount="indefinite"></animateTransform>
         </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',

  computed: {
    loadingClasses () {
      return {
        'ovp-loading': true,
        'ovp-loading--active': this.$loading.state.isLoading,
        'ovp-loading--blocking': this.$loading.state.isBlocking
      }
    }
  }
}
</script>

<style name="mobile" scoped>
.ovp-loading {
  position: fixed;
  z-index: 9999;
  top: 0;
  bottom: 0;
  left: -100%;
  right: 100%;
  transition: top .3s ease-in-out, bottom .3s ease-in-out, right .3s ease-in-out;

  &--blocking {
    background-color: rgba(19, 19, 19, .3);
  }

  &--active {
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    .indicator {
      left: 0 !important;
    }
  }

  .indicator {
    position: absolute;
    top: 60px;
    left: -150px;
    z-index: 10000;

    display: inline-block;
    height: 60px;
    width: 150px;
    padding: 13px;
    text-align: center;
    background: transparent;
    transition: left .3s ease-in-out;
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .ovp-loading {
    &--active {
      top: 0;
    }

    .indicator {
      top: 98px;
      height: 90px;
    }
  }
}
</style>
